import React from "react";
import "./PmkvyPage.css";
import BannerImage from "../Component/pmkvy.png"; // ✅ Your actual banner image

const PmkvyPage = () => {
  return (
    <div className="pmkvy-page">
      {/* 🔹 Banner Section */}
      <div className="pmkvy-banner">
        <img src={BannerImage} alt="PMKVY Banner" className="banner-img" />
      
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 pmkvy-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About PMKVY (Pradhan Mantri Kaushal Vikas Yojana)
        </h2>

        <p>
          The Pradhan Mantri Kaushal Vikas Yojana (PMKVY) is the flagship skill development
          program of the Government of India, implemented by the Ministry of Skill Development
          and Entrepreneurship (MSDE). Its primary objective is to encourage and empower youth
          to acquire industry-relevant skills and secure meaningful employment opportunities.
          As an approved training partner under PMKVY, CPIT provides high-quality, job-oriented
          training designed to meet the dynamic needs of today’s workforce.
        </p>

        <p>
          PMKVY focuses on competency-based skill development and recognizes the importance of
          both technical and soft skills. Through CPIT’s structured courses, students gain
          hands-on training in areas such as IT, accounting, communication, and technical trades.
          The curriculum is aligned with National Skill Qualification Framework (NSQF) standards,
          ensuring nationwide recognition of the certifications awarded to successful candidates.
        </p>

        <p>
          A key strength of the PMKVY initiative at CPIT is its focus on practical,
          employment-driven training. Students participate in live projects, real-world
          exercises, and simulations that build confidence and improve job readiness.
          Additionally, CPIT offers career counseling, interview preparation, and placement
          support to ensure that every learner transitions smoothly into the professional world.
        </p>

        <p>
          After successful completion, students receive government-recognized PMKVY certificates
          that enhance employability across sectors. The initiative plays a major role in bridging
          the skill gap in India by connecting youth talent with industry demand, helping create
          a self-reliant and skilled workforce for the nation’s growing economy.
        </p>
      </div>
    </div>
  );
};

export default PmkvyPage;
